// eslint-disable-next-line import/prefer-default-export
let TextOverflow = /*#__PURE__*/function (TextOverflow) {
  TextOverflow["Ellipsis"] = "Ellipsis";
  return TextOverflow;
}({});

export { TextOverflow };
//# sourceMappingURL=textOverflow.js.map
